	export enum SalesOrderLinesValidationTypeEnum {
		NonSerializedQuantityValidation = 1,
		WarrantyExpirationDateVaidation = 2,
		LegacySalesOrderLineSerializedItemExits = 3,
		NonInventoryOrderValidation = 4,
		InventoryOrderValidation = 5
	}
